export default {
  integrations: {
    web: "Web Integration",
    webEmbed: "Web Integration",
    webEmbedTip: "Build your web customer service live chat",
    clientNumberExceededTip:
      "The number of clients for this channel exceeds, please consult the product consultant",
    needUpgradeTo: "Need to upgrade to ",
    requiresUpgradeToProVersionForIntegration:
      "Requires upgrade to {version} version for integration",
    use: " Use",
    connect: "Connect",
    detailsPleaseConsult: ",Details please consult",
    selfBuildStep: "Self-built integration steps",
    customerOperation: "Customer Operation",
    discord: "Integrate your agent in discord chat",
    telegram: "Integrate your agent in telegram chat",
    hubspot: "Integrate your agent in hubspot",
    whatsapp: "Integrate your agent in whatsapp",
    selfBuild: "Self-built",
    hosting: "Hosting",
    exceededTip: "Client limit exceeded, please upgrade your plan",
    TheNumberofClients: "The number of clients in this channel",
    Client: "Client",
    exceeded: "exceeded",
    collaborationOffice: "Collaboration Office",
    integrationIntelligentReply: "Integrate your agent in slack",
    TheNumberofClients1: "The number of",
    clients1: "clients",
    forThisChannelExceeds1: "for this channel exceeds",
    basicInformation: "Basic Info",
    configurationInformation: "Authentication",
    bindClient: "Bind Client",
    configureClient: "Configure Client",
    selectYourDefaultApplication: "Select your agent or workflow",
    pleaseEnter: "Please enter",
    copy: "Copy",
    discordInvite: "Open in Discord",
    createCompleted:
      'Created successfully, click "Confirm" to go to client management for detailed configuration.',
    accessCompleted:
      'Access completed, you can go to "Client Management" for detailed configuration and management.',
    nextStep: "Next Step",
    pleaseFillIn: "Please fill in",
    bindSuccess: "Bind successfully",
    app: "App",
    workflow: "Workflow",
    dialogApi: "Chat API",
    dialogApiTip: "Integrate agents or workflows into your applications",
    dialogApiMemory: "Chat API with Memory",
    dialogApiMemoryTip: "Chat API with built-in contextual memory",
    workflowRunApi: "Workflow Run API",
    workflowRunApiTip: "Run workflow, support custom variables",
    APIKeyManagement: "API Keys",
    createAPIKey: "Create API Key",
    createTime: "Create Time",
    activeTime: "Active Time",
    confirmDelete: "Are you sure you want to delete this AppKey?",
    confirmDeleteTip: "After deletion, the AppKey will be invalid",
    transferToHuman: "Transfer to human setting",
  },
};
